// extracted by mini-css-extract-plugin
module.exports = {"header_area":"FeaturedOn_header_area__Wga8m","logo_container":"FeaturedOn_logo_container__t_S32","single_logo":"FeaturedOn_single_logo__a532a"};